<template>
  <div class="card-header border-0 bg-transparent">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
// Card header component - contains title and description
</script>
